import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Wallet icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Wallet } from '@sravni/design-system-icons'
 *
 * <Wallet />
 * ```
 */
var Wallet = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Wallet", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.143 14.201V15c0 1.183-.96 2.143-2.143 2.143H3.572A2.143 2.143 0 0 1 1.429 15V4.286M13.571 5.714H15c1.183 0 2.143.96 2.143 2.143v.714", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M13.572 5.714H2.857a1.428 1.428 0 1 1 0-2.857h9.286c.79 0 1.429.64 1.429 1.429v1.428ZM17.143 9.286H15a2.143 2.143 0 1 0 0 4.285h2.143", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M15.715 9.286h2.143c.394 0 .714.32.714.714v2.857c0 .394-.32.714-.714.714h-2.143", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }))); });

export { Wallet };
//# sourceMappingURL=Wallet.js.map
